import { Component, Inject, OnDestroy, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-add-rate-table',
  standalone: false,
  templateUrl: './add-rate-table.component.html',
  styleUrl: './add-rate-table.component.scss'
})
export class AddRateTableComponent  {

  constructor(public appService:AppService, 
   public dialogRef: MatDialogRef<AddRateTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,){
      // if(dialogRef)
      dialogRef.disableClose = true;
    }
  // constructor(public appService:AppService, ){}

  onSelectFormat(type:string){
    this.appService.emitCOunt = true;
    this.appService.matrixEmitter.emit(type)   
    this.onCloseBtn();
  }

  onCloseBtn(){
    // if(this.dialogRef)
    this.dialogRef.close({ operation: 'close' });
  }
}
